import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { map, pairwise, ReplaySubject, tap, withLatestFrom } from "rxjs";
import { AppState } from "src/app/shared/store/app.state";
import { QuoteFeatureState } from "src/app/shared/store/quote/term-life-insurance/quote.state";
import * as NotificationSelectors from "../../../../store/notification/notification.selectors";
import * as QuoteSelectors from "../../../../store/quote/term-life-insurance/quote.selectors";
import { NotificationService } from "../../notification.service";
import { NotificationQuoteService } from "./notification-quote.service";

@Injectable({
  providedIn: "root",
})
export class NotificationPublisherService {
  private readonly _quoteFeatureStateReplaySubject =
    new ReplaySubject<QuoteFeatureState>(2);

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _notificationQuoteService: NotificationQuoteService,
    private readonly _notificationService: NotificationService,
  ) {}

  start() {
    this.connectQuoteFeatureStateToReplaySubject();
    this.startListeningToQuoteFeatureStateChanges();
  }

  private connectQuoteFeatureStateToReplaySubject() {
    this._store
      .select(QuoteSelectors.selectFeatureState)
      .subscribe(this._quoteFeatureStateReplaySubject);
  }

  private startListeningToQuoteFeatureStateChanges() {
    this._quoteFeatureStateReplaySubject
      .pipe(
        pairwise(),
        withLatestFrom(
          this._store.select(NotificationSelectors.selectNotificationMessages),
        ),
        map(
          ([
            [previousQuoteFeatureState, currentQuoteFeatureState],
            notificationMessages,
          ]) =>
            this._notificationQuoteService.createNotificationPayloads(
              previousQuoteFeatureState,
              currentQuoteFeatureState,
              notificationMessages,
            ),
        ),
        tap((notificationMessages) => {
          if (notificationMessages) {
            this._notificationService.createNotificationMessages(
              notificationMessages,
            );
          }
        }),
      )
      .subscribe();
  }
}
